import React, { useEffect, useState } from "react";
import { Form, Select, Button, Row, Col, Steps, message } from "antd";
import { useSocket } from "@components/SocketProvider";
import planningService from "@services/planning.service";
import FileDownload from "js-file-download";

const { Step } = Steps;

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
};
/* eslint-enable no-template-curly-in-string */

let interval = undefined;

const downloadFile = (url) => {
  const e = document.createElement("a");
  e.href = url;
  e.download = url.substr(url.lastIndexOf("/") + 1);
  document.body.appendChild(e);
  e.click();
  document.body.removeChild(e);
};

const Borders_Rightel = () => {
  // eslint-disable-next-line
  const socket = useSocket();

  const [submitted, setSubmitted] = useState(false);
  const [fileLink, setFileLink] = useState("");
  const [progress, setProgress] = useState(0);
  const [form] = Form.useForm();

  useEffect(() => {
    if (submitted) {
      interval = setInterval(() => {
        setProgress((prev) => prev + 1);
      }, 100);
    } else {
      clearInterval(interval);
    }
  }, [submitted]);

  useEffect(() => {
    if (progress === 100 && fileLink) {
      setSubmitted(false);
      clearInterval(interval);
      downloadFile(fileLink);
    }
    // eslint-disable-next-line
  }, [progress]);

  useEffect(() => {
    socket.on("progress", function (data) {
      // console.log("progress", data);
      setProgress(data);
    });

    socket.on("message", function (data) {
      // console.log("message", data);
      if (data.s === 0) {
        setSubmitted(false);
        message.error(data.message);
      }
    });
    // eslint-disable-next-line
  }, []);

  const onFinish = async (values) => {
    setProgress(0);
    setSubmitted(true);
    setFileLink("");
    try {
      const res = await planningService.downloadBordersRightel({
        ...values,
        io_id: socket.id,
      });

      const contentDisposition = res.headers["content-disposition"];
      const startIndex = contentDisposition.indexOf("filename=") + 10; // Adjust '+ 10' if filename is not the right one.
      const endIndex = contentDisposition.length - 1; //Check if '- 1' is necessary
      const filename = contentDisposition.substring(startIndex, endIndex);

      FileDownload(res.data, filename);

    } catch (err) {
      console.log(err);
    } finally {
      setSubmitted(false);
    }
  };

  return (
    <div className="p-5 h-full img-bg img-bg-google-earth">
      <div className="bg-white border border-gray-200 rounded-md p-5 flex-grow">
        <Form
          form={form}
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          validateMessages={validateMessages}
        // onValuesChange={handleFormValuesChange}
        >
          <Row gutter={[14, 0]}>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
              <Form.Item
                name="border"
                label="Border"
                rules={[
                  {
                    // type: "array",
                    required: true,
                  },
                ]}
              >
                <Select
                  //   mode="multiple"
                  allowClear
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  maxTagCount={5}
                  options={[
                    { label: "RNC", value: "RNC" },
                    { label: "TAC", value: "TAC" },
                    { label: "Region", value: "Region" },
                    { label: "Province", value: "Province" },
                    { label: "City", value: "City" },
                  ]}
                />
              </Form.Item>
            </Col>

            <Col flex="auto" className="flex justify-end items-end">
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={submitted}
                  className="mt-4"
                >
                  Download
                </Button>
                <Button
                  style={{ margin: "0 8px" }}
                  onClick={() => {
                    form.resetFields();
                  }}
                >
                  Clear
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {submitted && (
          <div className="mt-10">
            <Steps
              percent={progress}
              current={
                progress < 25 ? 0 : progress < 50 ? 1 : progress < 75 ? 2 : 3
              }
              direction="horizontal"
              className="mt-5"
            >
              <Step
                title={progress < 20 ? "In Progress" : "Finished"}
                description="Waiting for server response"
              />
              <Step
                title={
                  progress < 25
                    ? "Waiting"
                    : progress < 50
                      ? "In Progress"
                      : "Finished"
                }
                description="Read from Database"
              />
              <Step
                title={
                  progress < 50
                    ? "Waiting"
                    : progress < 75
                      ? "In Progress"
                      : "Finished"
                }
                description="Create Excel file"
              />
              <Step
                title={
                  progress < 75
                    ? "Waiting"
                    : progress < 100
                      ? "In Progress"
                      : "Finished"
                }
                description="Download"
              />
            </Steps>
          </div>
        )}
      </div>
    </div>
  );
};

export default Borders_Rightel;
